import { NavigationBar } from '@/components/NavigationBar/NavigationBar'
import { Sidebar } from '@/components/Sidebar/Sidebar'
import { Content, Shell } from '@hivemq/ui-library'
import type { PropsWithChildren } from 'react'

export function Layout({ children }: Readonly<PropsWithChildren>) {
  return (
    <Shell.Root sidebarWidth="var(--sidebar-width)">
      <NavigationBar />
      <Sidebar />

      <Content.Root as="main">{children}</Content.Root>
    </Shell.Root>
  )
}
